import { Card, Grid, Typography, Button, FormControlLabel, Checkbox, TextField, Box, Alert, AlertTitle } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Field, FormikProvider, useFormik } from 'formik';

import * as Yup from "yup";
import api from '../../redux/features/auth/axiosAuthHelper';
import dayjs from 'dayjs';
import { TextEditField, TextEditReadOnlyField, FormDatePicker, TestTypeSelectField } from '../../components/common/fields/fields';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import colorConfigs from '../../configs/colorConfigs';
import { BatchSessionStorageKey, BatchTableParameterStorageService } from '../../services/sessionStorage';
import RareButton from '../../components/common/buttons/RareButton';
import NotificationSnackbarCard from '../../components/common/cards/NotificationSnackbarCard';

interface KeysPageDetailProps {

}


const KeysPage: React.FC<KeysPageDetailProps> = ({ }) => {
  const authData = useSelector((state: RootState) => state.auth);
  const [errors, setErrors] = useState<string | null>(null);
  const [initialValues, setInitialValues] = useState<any>({})
  const [updatedValues, setUpdatedValues] = useState<any>({})
  const [hasMadeChanges, setHasMadeChanges] = useState<boolean>(false)
  const [key, setKey] = useState<any>();
  const [errorQueue, setErrorQueue] = useState<string[]>([]);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  // Fetch key data and point_model JSON data
  useEffect(() => {
    const fetchKey = async () => {
      try {
        const url = `data-mappings/encryption-key/`;

        const response = await api.get(url, {
          headers: {
            'Authorization': `Bearer ${authData.access}`
          }
        });
        console.log(response.data)
        setKey(response.data);
      } catch (error) {
        console.error('Error fetching encryption key', error);
        setErrors(`No Key found`)
        setTimeout(() => {
          // handleBackButton()
        }, 4000);
      }
    };
    fetchKey();
  }, []
  );

  const validationSchema = () => {
    return Yup.object().shape({
      key: Yup.string().required("This field is required"),
      value: Yup.string().required("This field is required")
    });
  }

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: key ? {
      key: key.key,
      value: key.value,
    } : {
      key: "",
      value: "",
    },
    validationSchema,
    onSubmit: async (values) => {

      setErrorQueue([]);
      setSuccessMessage(null)
      const data = authData.isPortalUser ? {
        key: values.key,
        value: values.value,
      } : {}

      const url = key ? `data-mappings/${values.key}/` : `data-mappings/`
      const method = key ? 'patch' : 'post'

      try {
        console.log("data", data)
        await api({
          method,
          url,
          data,
          headers: {
            'Authorization': `Bearer ${authData.access}`,
          },
        });
        setErrors(null);
        console.log("Encryption Key successfully updated")
        setSuccessMessage("Encryption Key successfully updated");
        // handleRefreshButton() // reset states and close popup
      } catch (error: any) {
        if (error?.response?.status === 400) {
          const firstErrorItem = Object.keys(error.response.data)[0];
          setErrors(`${firstErrorItem}: ${error.response.data[firstErrorItem]}`);
          setErrorQueue([`${firstErrorItem}: ${error.response.data[firstErrorItem]}`]);
        } else if (error?.response?.status === 403) {
          const firstErrorItem = Object.keys(error.response.data)[0];
          setErrors(`${error.response.data[firstErrorItem]}`);
          setErrorQueue([`${error.response.data[firstErrorItem]}`]);
        } else {
          const errorText = `Unknown error updating Encryption Key`;
          setErrors(errorText);
          setErrorQueue([errorText]);
          console.error(errorText, error);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
  });


  // Effect to set initial form values from batch to check for form changes
  useEffect(() => {
    setTimeout(() => {
      setInitialValues(formik.initialValues);
      setUpdatedValues(formik.initialValues);
    }, 500);
    setHasMadeChanges(false);
  }, [key]);

  // Update the updatedValues state when formik values change
  useEffect(() => {
    setUpdatedValues(formik.values);
  }, [formik.values]);

  // Function to check if form has changed so the save button becomes active on edit
  const hasFormChanged = (flatModel: Record<string, any>, formValues: Record<string, any>): boolean => {
    for (const key in formValues) {
      if (key === "expiry_date") {

      } else {
        if (formValues[key] != flatModel[key]) {
          console.log("Changed Data", formValues[key], flatModel[key])
          return true;
        }
      }
    }
    return false;
  };

  // Use Effect to check if any changes ahve been made to the form on Edit
  useEffect(() => {
    if (key) {
      if (Object.keys(initialValues).length > 0 && Object.keys(updatedValues).length > 0) {
        const formChanged = hasFormChanged(initialValues, updatedValues);
        setHasMadeChanges(formChanged);
      }
    }
  }, [updatedValues, initialValues, key]);

  // Use Effect set save button active on load if Create and if changes are made on Edit
  useEffect(() => {
    setHasMadeChanges(false);
  }, []);

  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit} style={{ overflow: 'auto' }}>
        <Box data-testid="Box-rdwp" sx={{ height: "100%", p: 2, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          {errors && (
            <Alert data-testid="Alert-u1vh" severity="error" style={{ width: "59.5%" }}>
              <AlertTitle data-testid="AlertTitle-sjr5">Error</AlertTitle>
              {errors}
            </Alert>
          )}
          <div data-testid="div-7ba7" style={{ width: "100%", height: "100%", margin: "auto", padding: "1em", display: "flex", alignItems: "center" }}>
            <Grid container spacing={5} alignItems="top" justifyContent="center" sx={{ minWidth: "100%", padding: 5 }}>
              <Grid item xs={12} md={5} style={{ display: "flex", flexDirection: "column", }}>
                <Card data-testid="Card-367e" sx={{ pb: 1, boxShadow: 10, height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
                  <Box data-testid="Box-72ot" sx={{ display: 'flex' }}>
                    <Box data-testid="Box-drhv" sx={{ height: '100%', background: colorConfigs.tables.headBg, display: 'flex', alignItems: 'center', borderBottomRightRadius: 3 }}>
                      <Typography data-testid="Typography-3449" sx={{ px: 2, py: 0.5, color: '#fff', fontWeight: 'bold', fontSize: '20px' }}>Encryption Key</Typography>
                    </Box>
                  </Box>
                  <Box data-testid="Box-y9r4" sx={{ p: 2, pt: 3, height: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {/* <Field data-testid="Field-36xm" name="key" type="text" className="form-control" label="Encryption Key Name" component={key?.key ? TextEditReadOnlyField : TextEditField} /> */}
                    <Field data-testid="Field-o9o5" name="value" type="text" className="form-control" label="Value" component={TextEditField} />
                  </Box>

                  <div data-testid="div-5vhs" className="form-group" style={{ width: "100%", display: 'flex', alignItems: 'center', justifyContent: "flex-end" }}>
                    <RareButton data-testid="RareButton-27e9"
                      type="submit"
                      variant="success"
                      disabled={!hasMadeChanges}
                      sx={{
                        position: "relative",
                        m: 1,
                      }}
                    >
                      Save Changes
                    </RareButton>
                  </div>

                </Card>
              </Grid>

            </Grid>
          </div>
          <NotificationSnackbarCard
            errorQueue={errorQueue}
            successMessage={successMessage}
            setErrorQueue={setErrorQueue}
            setSuccessMessage={setSuccessMessage}
          />
        </Box>
      </form>
    </FormikProvider>
  )
}

export default KeysPage;